import ScheduleDelivery from "./ScheduleDelivery";

export default ScheduleDelivery;
